import React from "react";
import { Page, Text, View, Link, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const FirstPage = ({ reportName, buildingName, start, end }) => {
  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: 40,
      lineHeight: 1.5,
      fontSize: 14,
    },
    row: { flexDirection: "row" },
    divider: {
      height: 1,
      backgroundColor: "gray",
      width: "100%",
      marginTop: 10,
      marginBottom: 10,
    },
    title: {
      fontSize: 24,
      fontFamily: "Helvetica-Bold",
      marginTop: 5,
      marginBottom: 5,
    },
    sectionTitle: {
      fontSize: 18,
      fontFamily: "Helvetica-Bold",
      marginTop: 5,
      marginBottom: 5,
    },
    hint: {
      fontSize: 12,
      color: "gray",
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
  });
  const headerNames = ["Building:", "Start Time:", "End Time:"];
  const headerValues = [buildingName, start, end];
  return (
    <Page size="A4" style={styles.page}>
      <View id={"header"} style={styles.header}>
        <View>
          <Text style={styles.hint}>CBM Smart Toilet System</Text>
          <Text style={styles.title}>{`System Report - ${reportName}`}</Text>
          {headerNames.map((n, i) => (
            <View style={[styles.row]} key={n}>
              <Text style={{ width: 75, color: "gray" }}>{n} </Text>
              <Text>{headerValues[i]} </Text>
            </View>
          ))}
        </View>
        <View style={[styles.hint]}>
          <Text>{moment().format("MMMM D, YYYY")}</Text>
        </View>
      </View>
      <View style={styles.divider} />
    </Page>
  );
};

export default FirstPage;
